"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const CommonDto_1 = require("../dto/CommonDto");
class Image {
    constructor(url, width, height) {
        this.url = url;
        this.width = width;
        this.height = height;
    }
    static createEmpty() {
        return new Image("", 0, 0);
    }
    static copy(source, target) {
        target.url = source.url;
        target.width = source.width;
        target.height = source.height;
        return target;
    }
    size() {
        return this.width + "x" + this.height;
    }
    static fromDto(imageDto) {
        return new Image(imageDto.url, imageDto.width, imageDto.height);
    }
    static fromOptionalDto(optionalImage) {
        if (!optionalImage) {
            return null;
        }
        if (optionalImage.type === CommonDto_1.OptionalImageType.EMPTY) {
            return null;
        }
        return new Image(optionalImage.url, optionalImage.width, optionalImage.height);
    }
}
exports.Image = Image;
